import { z } from 'zod';
/** Pessoa autenticada pelo Teams (SSO), por outro login do Entra ID ou em dev. */
export const userPrincipalSchema = z.strictObject({
    kind: z.literal('user'),
    id: z.uuid(),
    name: z.string(),
    email: z.string(),
    /** Códigos dos perfis da pessoa. Sem perfil, não há permissão nenhuma. */
    roles: z.array(z.string()),
});
/** Integração autenticada por client credentials (M2M). */
export const appPrincipalSchema = z.strictObject({
    kind: z.literal('app'),
    /** Client ID do app que pediu o token. */
    appId: z.string(),
});
export const principalSchema = z.discriminatedUnion('kind', [
    userPrincipalSchema,
    appPrincipalSchema,
]);
/**
 * Resposta de `GET /api/auth/me`: quem está chamando e o que pode fazer. Com
 * o catálogo da aplicação, as chaves são conferidas uma a uma.
 */
export const sessionSchemaOf = (catalog) => z.strictObject({
    principal: principalSchema,
    permissions: z.array(catalog.schema),
});
/** A mesma resposta, sem conhecer o catálogo: para a documentação. */
export const sessionSchema = z.strictObject({
    principal: principalSchema,
    permissions: z.array(z.string()),
});
//# sourceMappingURL=session.contract.js.map